// @flow
import React from "react";
import { withStyles } from "@material-ui/core";
import Form from "../containers/Create";
import styles from "../styles/styles";

const layout = () => (
    <div>
        <Form />
    </div>
);

export default withStyles(styles)(layout);
